/** Dateiname aus `Content-Disposition`; `filename*` (RFC 5987) geht dem ASCII-`filename` vor. */
export function filenameFromContentDisposition(contentDisposition: string | null, fallback: string): string {
  if (!contentDisposition) return fallback;
  const extended = /filename\*=[\w-]+'[^']*'([^;]+)/i.exec(contentDisposition);
  if (extended) {
    try {
      return decodeURIComponent(extended[1].trim());
    } catch {
      return fallback;
    }
  }
  const basic = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return basic ? basic[1].trim() : fallback;
}

/**
 * Speichert einen Blob als Datei.
 *
 * <p>Der Anker muss im Dokument haengen: Firefox loest einen Klick auf ein loses Element nicht
 * zuverlaessig aus. Und die Objekt-Adresse wird erst im naechsten Durchlauf freigegeben — gibt
 * man sie sofort frei, kann der Browser den Download abbrechen, bevor er ihn begonnen hat.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url));
}
